import {Box,Checkbox,Dialog,DialogContent,Table,TableBody,TableCell,TableHead,TableRow,TextField,Typography,Stack,} from "@mui/material";
import { useState } from "react";
import { farmers, region } from "../../config/images";
import "./Region.css";
import { deleteRegionList, updateRegionList,} from "../../config/services";
import Pagination from "@mui/material/Pagination";
import { styled } from "@mui/material/styles";
import translations from "../../config/language";
import { notifyError, notifySuccess } from "../../config/ToastMessage";
import { useSelector } from "react-redux";

const RegionTable = ({
  regionData,
  setRegionUpdated,
  regionCurrentPage,
  setRegionCurrentPage,
  regionCount,
  perPage,
  selectedRegionsTable,
  setSelectedRegionsTable
}) => {
  const [editRegionPopup, setEditRegionPopup] = useState(false);
  const [deleteRegionPopup, setDeleteRegionPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [regionName, setRegionName] = useState();
  const [regionId, setRegionId] = useState();

  const { module_access } = useSelector((state) => state.userState)
  const isAccess = module_access?.find((module) =>
    module.module_name === "Region & Locality" && module.is_editor === true
  ) ? true : false;

  const handleOpenEditDialog = (e) => {
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    setRegionName(e.region_name);
    setRegionId(e.id);
    setEditRegionPopup(true);
  };
  const handleEditRegion = async (e) => {
    e.preventDefault();
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    try {
      setLoading(true);
      const params = {
        region_name: regionName,
      };
      const resp = await updateRegionList(regionId, params);

      if (resp.data.success == true) {
        setEditRegionPopup(false);
        notifySuccess(resp.data.message);
        setRegionUpdated(true); //  ✅ Trigger region refresh
        setTimeout(() => {
          setLoading(false);
        }, 2000);
      }
    } catch (error) {
      console.log(error);
      notifyError(error.response.data.message);
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }
  };
  const handleOpenDeleteDialog = async (id) => {
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    setDeleteRegionPopup(true);
    setRegionId(id);
  };
  const handleDeleteRegion = async (e) => {
    e.preventDefault();
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    try {
      setLoading(true);
      const resp = await deleteRegionList(regionId);
      setDeleteRegionPopup(false);
      notifySuccess(resp.data.message);
      setRegionUpdated(true); //  ✅ Trigger region refresh
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    } catch (error) {
      console.log("error");
      notifyError(error.response.data.message);
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }
  };
  const CustomPagination = styled(Pagination)(({ theme }) => ({
    "& .MuiPaginationItem-root": {
      borderColor: "none",
      borderWidth: "none",
      borderStyle: "none",
      marginTop: "30px",
    },
    "& .Mui-selected": {
      borderColor: "#31A05F",
      backgroundColor: "#31A05F !important",
      color: "#ffffff !important",
    },
  }));
  const handlePageChange = (event, value) => {
    setRegionCurrentPage(value);
  };

  const language = process.env.REACT_APP_LANGUAGE;

  const handleRowSelect = (id) => {
    setSelectedRegionsTable((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((item) => item !== id)
        : [...prevSelected, id]
    );
  };
  // Function to handle "Select All"
  const handleSelectAll = () => {
    if (selectedRegionsTable.length === regionData.length) {
      setSelectedRegionsTable([]); // Uncheck all
    } else {
      setSelectedRegionsTable(regionData.map((e) => e.id)); // Select all
    }
  };
  return (
    <>
      <Box  className="table-container">
        <Table className="region-table" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell style={{ width: "50px" }}>
                <Checkbox
                  sx={{
                    color: "rgba(225, 230, 244, 1)",
                    borderRadius: "4px",
                    "&.Mui-checked": {
                      color: "rgba(199, 206, 227,1)",
                    },
                  }}
                  checked={selectedRegionsTable.length === regionData.length}
                  onChange={handleSelectAll}
                />
              </TableCell>
              <TableCell style={{ width: "100px" }}>
                {translations[language].srNo}
              </TableCell>
              <TableCell>{translations[language].regionName}</TableCell>
              <TableCell style={{ width: "100px" }}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {regionData?.length > 0 ? regionData.map((e, i) => {
              return (
                <TableRow>
                  <TableCell>
                    <Checkbox
                      sx={{
                        color: "rgba(225, 230, 244, 1)",
                        borderRadius: "4px",
                        "&.Mui-checked": {
                          color: "rgba(199, 206, 227,1)",
                        },
                      }}
                      checked={selectedRegionsTable.includes(e.id)}
                      onChange={() => handleRowSelect(e.id)}
                    />
                  </TableCell>
                  {/* <TableCell>{i + 1}</TableCell> */}
                  <TableCell style={{ textAlign: "center" }}>
                    {i + 1 + (regionCurrentPage - 1) * perPage}
                  </TableCell>
                  <TableCell>{e.region_name}</TableCell>
                  <TableCell>
                    <div className="d-flex gap-3">
                      <img
                        src={region.editIcon}
                        alt=""
                        onClick={() => handleOpenEditDialog(e)}
                        style={{ cursor: "pointer", height: "23px" }}
                      />
                      <img
                        src={region.deleteIcon}
                        alt=""
                        onClick={() => handleOpenDeleteDialog(e.id)}
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                  </TableCell>
                </TableRow>
              );
            }): <TableRow>
            <TableCell colSpan={4} style={{ textAlign: "center" }}>
              <img src={farmers.noData} alt="No Data" />
            </TableCell>
          </TableRow>}
          </TableBody>
        </Table>
      </Box>
      <Box
        display="flex"
        justifyContent="end"
        alignItems="center"
        className="pagination"
      >
        <Stack spacing={2}>
          <CustomPagination
            count={Math.ceil(regionCount / perPage)}
            page={regionCurrentPage}
            onChange={handlePageChange}
            color="primary"
          />
        </Stack>
      </Box>

      <Dialog
        open={editRegionPopup}
        // onClose={() => setEditRegionPopup(false)}
        maxWidth="xs"
        fullWidth
        disableScrollLock
        PaperProps={{
          sx: { borderRadius: "12px" },
        }}
        // className="dialog-assign"
      >
        <div className="assign-div">
          {" "}
          <div className="d-flex justify-content-around align-items-center">
            <h5 className="p-3 mb-0" style={{ textAlign: "center" }}>
              {translations[language].editRegion}
            </h5>
          </div>
        </div>
        <DialogContent>
          <form noValidate autoComplete="off">
            <TextField
              fullWidth
              label="Enter Region"
              name="regionName"
              value={regionName}
              onChange={(e) => setRegionName(e.target.value)}
              className="mb-3"
            />

            <div className="d-flex gap-3 mt-2">
              <button
                className="cancel-button"
                onClick={(e) => {
                  e.preventDefault();
                  setEditRegionPopup(false);
                }}
              >
                {translations[language].cancel}
              </button>
              <button
                className="assign-task-button"
                onClick={(e) => handleEditRegion(e)}
                disabled={loading}
              >
                {loading ? (
                  <span className="spinner"></span>
                ) : (
                  translations[language].updateRegion
                )}
              </button>
            </div>
          </form>
        </DialogContent>
      </Dialog>

      <Dialog
        open={deleteRegionPopup}
        // onClose={() => setDeleteRegionPopup(false)}
        maxWidth="xs"
        disableScrollLock
        PaperProps={{
          sx: { borderRadius: "12px" },
        }}
      >
        <DialogContent className="p-5" style={{ textAlign: "center" }}>
          <Box>
            <img src={region.correct} alt="" />
          </Box>
          <Typography variant="h5" className="pt-4 mb-2">
            <b>{translations[language].deleteRegion}</b>
          </Typography>
          <Typography variant="p" className="pt-4" style={{ fontSize: "16px" }}>
            {translations[language].deleteRegionConfirmation}
          </Typography>
          <div className="d-flex gap-3 pt-4">
            <button
              className="assign-task-button"
              onClick={(e) => handleDeleteRegion(e)}
              disabled={loading}
            >
              {loading ? (
                <span className="spinner"></span>
              ) : (
                translations[language].yes
              )}
            </button>
            <button
              className="assign-task-button"
              onClick={() => setDeleteRegionPopup(false)}
            >
              {translations[language].no}
            </button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default RegionTable;